import i18next from "i18next";
import axios from "axios";
import fr from "./locales/fr.json";
import yo from "./locales/yo.json";
import ig from "./locales/ig.json";
import ha from "./locales/ha.json";

export const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "yo", label: "Yorùbá", short: "YO" },
  { code: "ig", label: "Igbo", short: "IG" },
  { code: "ha", label: "Hausa", short: "HA" },
];

const STORAGE_KEY = "epl_lang";
const CODES = LANGS.map((l) => l.code);

const detect = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && CODES.includes(saved)) return saved;
  } catch {}
  const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
  return CODES.includes(nav) ? nav : "en";
};

export const currentLang = detect();

i18next.init({
  lng: currentLang,
  fallbackLng: "en",
  initImmediate: false,
  keySeparator: false,
  nsSeparator: false,
  returnEmptyString: false,
  interpolation: { escapeValue: false },
  resources: {
    fr: { translation: fr },
    yo: { translation: yo },
    ig: { translation: ig },
    ha: { translation: ha },
  },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = currentLang;
}
axios.defaults.headers.common["X-Lang"] = currentLang;

export const t = (key, opts) => {
  if (typeof key !== "string" || !key) return key;
  return i18next.t(key, opts);
};

// Identity marker: keeps raw English values (e.g. form option values) but
// flags the strings for extraction so they can be displayed via t().
export const K = (v) => v;

export const setLanguage = (code) => {
  if (!CODES.includes(code) || code === currentLang) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, code);
  } catch {}
  window.location.reload();
};

// Keys whose values are never prose (ids, urls, media, lookup keys).
export const SKIP_KEYS = new Set([
  "id", "slug", "sku", "key", "code", "href", "to", "url", "src", "path",
  "image", "imageDetail", "images", "img", "logo", "icon", "Icon", "video",
  "poster", "gallery", "orchardImage", "color", "bg", "accent", "className",
  "class", "logoClass", "testid", "currency", "email", "phone", "tel",
  "whatsapp", "tags", "category", "type_id", "status", "interest", "value_id",
  "font", "style", "bgClass", "textClass", "hex", "swatch", "gradient",
]);

const isReactType = (v) => v && typeof v === "object" && "$$typeof" in v;

// Deep-localise every prose string inside a plain data structure.
export const L = (value, parentKey) => {
  if (parentKey && SKIP_KEYS.has(parentKey)) return value;
  if (typeof value === "string") return t(value);
  if (Array.isArray(value)) return value.map((v) => L(v, parentKey));
  if (
    value &&
    typeof value === "object" &&
    !isReactType(value) &&
    Object.getPrototypeOf(value) === Object.prototype
  ) {
    const out = {};
    for (const k of Object.keys(value)) out[k] = L(value[k], k);
    return out;
  }
  return value;
};

export default i18next;
